export default __webpack_public_path__ + "static/media/WorkSans-VariableFont_wght.e7663f1a.ttf";